module.exports = __webpack_public_path__ + "static/penny-static-ce5d389401fab23933ac3f134e720739.jpg";